import { createContext } from 'react';

export const CompareSettings = createContext();
